// Generate the listsend per-company token used to authenticate the user
// when redirecting from Vesta into listsend.eventvesta.com. Single source
// of truth — both the channel card on /marketing and the email product
// page CTA call buildListsendDashboardUrl() from this file.
//
// The base URL has NO trailing slash so callers can join with /c/... and
// produce a clean single-slash path. Earlier versions had a double slash
// (`//c/`) which servers usually normalize but is fragile.

export const LISTSEND_BASE_URL = "https://listsend.eventvesta.com"

export const getCompanyDataFromDOM = () => {
  const reactRoot = document.getElementById("react-root")
  const companyId = reactRoot?.getAttribute("company-id")
  const companyName = reactRoot?.getAttribute("company-name") || ""
  return { companyId, companyName }
}

export const generateCompanyToken = (companyId, companyName) => {
  if (!companyId) return null

  const cleanName = (companyName || "").replace(/[^a-zA-Z]/g, "").toLowerCase()

  let firstLetter
  let lastLetter
  if (cleanName.length === 0) {
    const idNum = parseInt(companyId, 10)
    firstLetter = String.fromCharCode(97 + (idNum % 26))
    lastLetter = String.fromCharCode(97 + ((idNum * 7) % 26))
  } else {
    firstLetter = cleanName[0]
    lastLetter = cleanName[cleanName.length - 1]
  }

  const offsetId = (parseInt(companyId, 10) + 123).toString()
  return `${companyId}${firstLetter}${lastLetter}${offsetId}`
}

// Builds the listsend dashboard URL for the currently-active company, or
// null if the company DOM attributes are missing. Caller is responsible for
// the actual navigation (window.location.href = ... or a new-tab open).
export const buildListsendDashboardUrl = () => {
  const { companyId, companyName } = getCompanyDataFromDOM()
  const token = generateCompanyToken(companyId, companyName)
  if (!token) return null
  return `${LISTSEND_BASE_URL}/c/${token}/dashboard`
}
